<div class="background" style="overflow-x: hidden;">
  <app-website-header></app-website-header>

  <div class="row">
    <div class="image-container">
      <img
        [src]="(screenSize.width < 400) ? ('../../../../assets/images/labs-c.jpg') : '../../../../assets/images/hospital_center_jpg.jpg'"
        alt="landingpage" class="landingpageimage" />
      <div class="header-name">
        <p>Healthcare Network</p>
      </div>
    </div>
  </div>

  <div class="mx-3 mt-2">
    <img class="breadcrumb-icon" src="../../../assets/images/icons/home-icon.svg" style="margin-top: -5px;" alt=""
      routerLink="/">
    <a class="breadcrummb ps-2" style="color:#0D87C8 ;" routerLink="/">Home</a>
    <a class="breadcrummb" style="color:#0D87C8 ;">/</a>
    <a class="breadcrummb" style="color:#0D87C8 ;">Healthcare Network</a>
    <a class="breadcrummb" style="color:#0D87C8 ;">-</a>
    <a class="breadcrummb" style="color:#0D87C8 ;">{{selectedHealth}}</a>
  </div>

  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-3">
        <app-hospital-filters [data]="originalHospitalsData"
          (filteredData)="onFilteredData($event)"></app-hospital-filters>
      </div>
      <div class="col-lg-9 hospital-banner" [ngClass]="{
        'doctors-page' : selectedHealth === 'Doctors' }">
        <div class="row hospital-banner-sub-div" style="width: 99%;">
          <div class="d-flex justify-content-between headers">
            <h2 class="hospitals" style="font-weight: bolder; font-size:12; font-family: 'Georgia' !important;">
              <img [src]="
                      selectedHealth === 'Doctors' ? '/assets/images/doctor_3216252.svg' :
                      selectedHealth === 'Hospitals' ? '/assets/images/hospitals-ribbon-icon.svg' :
                      '/assets/images/labs-microscope.svg'
                    " width="24px" height="24px" alt="" style="margin-right: 8px; margin-top: -6px;">
              {{ selectedHealth === 'Doctors' ? 'Doctors' :selectedHealth === 'Hospitals'? 'Hospitals': selectedHealth
              === 'Labs'? 'Labs': 'Clinics' }}
            </h2>
          </div>
        </div>
        <div *ngIf="(originalHospitalsData.length === 0 || noData) && !loading" class="no-results">
          <img src="../../../../assets/images/Empty bin.png" alt="no-records-found" class="no-results-image">
          <div class="no-records-found"> No Records Found </div>
        </div>
        <div class="row mt-4" *ngIf="this.selectedHealth !== 'Doctors'">
          <div class="col-lg-4" *ngFor="let hospital of paginatedItems; let i = index">

            <div class="card" (click)="viewHospitalsProfile(hospital)" style="position: relative;"
              (mouseenter)="hoveredIndex = i" (mouseleave)="hoveredIndex = -1"
              [ngStyle]="{'background-color': hoveredIndex === i ? 'rgba(0, 0, 0, 0.6)' : 'white', 'color': hoveredIndex === i ? '#fff' : 'inherit',}">
              <ng-container
                *ngIf="this.selectedHealth === 'Hospitals' || this.selectedHealth === 'Clinics' || this.selectedHealth === 'Labs'; else elseDoctors">
                <img [src]="hospital.logo" alt="{{hospital.organization}}" height="180px"
                  [style.opacity]="hoveredIndex === i ? 0.1 : 1" />
                <p class="hospital-name" [style.opacity]="hoveredIndex==i ? 0.1 : 1" style="font-weight: 700;">
                  {{hospital.organization}}</p>
                <p class="text-center"
                  style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
                  [style.display]="hoveredIndex === i ? 'block' : 'none'"
                  [style.background-color]="hoveredIndex === i ? '' : 'rgba(0, 0, 0, 0.6)'"
                  [style.color]="hoveredIndex === i ? '#fff' : 'rgba(0, 0, 0, 0.6)'" [style.font-weight]="'600'">
                  View {{hospital.organization}} Profile
                </p>
              </ng-container>
              <ng-template #elseDoctors>
                <div class="logoo">
                  <img [src]="hospital.logo" alt="{{hospital.name}}" width="100%" height="auto"
                    [style.opacity]="hoveredIndex === i ? 0.1 : 1" />
                </div>
                <p class="hospital-name" [style.opacity]="hoveredIndex==i ? 0.1 : 1" style="font-weight: 700;">
                  {{hospital.name}}</p>
                <p class="hospital-names" [style.opacity]="hoveredIndex==i ? 0.1 : 1" style="font-weight: 700;">
                  {{hospital.positionName}}</p>
                <p class="text-center"
                  style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
                  [style.display]="hoveredIndex === i ? 'block' : 'none'"
                  [style.background-color]="hoveredIndex === i ? '' : 'rgba(0, 0, 0, 0.6)'"
                  [style.color]="hoveredIndex === i ? '#fff' : 'rgba(0, 0, 0, 0.6)'" [style.font-weight]="'600'">
                  View {{hospital.name}} Profile
                </p>
              </ng-template>
            </div>
          </div>
        </div>
        <div *ngIf="this.selectedHealth === 'Doctors'" class="doctors-list-container">
          <div class="doctor-card" *ngFor="let doctor of paginatedItems; let i = index">
            <div class="doctor-background-frame"></div>
            <div class="doctor-profile-container">
              <div class="doctor-profile">
                <div class="doctor-profile-image">
                  <ng-container *ngIf="doctor?.logo; else noImage">
                    <img [ngClass]="{ 'doctor-logo-background': checkDoctorImageType(doctor?.logo) }"
                      [src]="doctor?.logo" alt="Doctor Profile Image">
                  </ng-container>
                  <ng-template #noImage>
                    <img src="../../../../assets/images/doctor-default-profile.png" alt="">
                  </ng-template>
                </div>
                <div class="doctor-detail-card">
                  <div class="doctor-detail" #doctorDetailElements>
                    <div class="doctor-name" #doctorNameElements>
                      {{ doctor?.name }}
                    </div>
                  </div>
                  <div>
                    <div class="bar"></div>
                    <div class="view-expert" (click)="viewHospitalsProfile(doctor)">
                      <span>Know The Expert</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="pagination-container d-flex align-items-center">
      <app-pagination [itemsPerPage]="itemsPerPage" [data]="hospitals" [currentPage]="currentPage - 1"
      (pageChangedWithInfo)="onPageChanged($event.data, $event.page)"></app-pagination>
      <p class="end-text" style="color: #0D87C8;margin-left: 25px;">Total Entries: {{hospitals.length}}</p>
    </div>
  </div>
</div>
<app-website-footer></app-website-footer>